import { Milestone } from '../types/milestone';
import { http, boolHttp } from './http';
import {
  GetMilestonesUrl,
  GetMilestoneUrl,
  PostMilestoneUrl,
  PutMilestoneUrl,
  DeleteMilestoneUrl,
} from './urls';

const getById = async (id: number): Promise<Milestone> => {
  const req = new Request(GetMilestoneUrl(id), { method: 'GET' });
  return await http<Milestone>(req);
};

const MilestoneService = {
  getAll: async (): Promise<Milestone[]> => {
    const req = new Request(GetMilestonesUrl(), { method: 'GET' });
    return await http<Milestone[]>(req);
  },

  getById,

  create: async (milestone: Milestone): Promise<Milestone> => {
    const req = new Request(PostMilestoneUrl(), {
      method: 'POST',
      body: JSON.stringify(milestone),
    });
    const id = await http<number>(req);
    return await getById(id);
  },

  update: async (milestone: Milestone): Promise<Milestone> => {
    const req = new Request(PutMilestoneUrl(), {
      method: 'PUT',
      body: JSON.stringify(milestone),
    });
    return await http<Milestone>(req);
  },

  delete: async (id: number): Promise<boolean> => {
    const req = new Request(DeleteMilestoneUrl(id), { method: 'DELETE' });
    return await boolHttp(req);
  },
};

export default MilestoneService;
